// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {
	CurrencyType,
	FridgeTransactionSubscription,
	TransactionState,
} from "../../../../src/gql/graphql";
import { WSDataVariant } from "../types";
import { removedMealsLargeOrder } from "./finishedTransaction.data";

export const dishRemovedFridgeTransactionBase: FridgeTransactionSubscription = {
	orders: {
		last: {
			id: "0d4ef945-f711-4275-9a1e-154c595f25fd",
			type: null,
			state: TransactionState.Active,
			user: {
				id: "874e7eeb-06bd-4eb5-8f3f-9e34b71ac205",
				name: "Playwright User",
				__typename: "UserSubscription",
			},
			inventory: {
				removed: [
					{
						id: "556baf7b-cdbe-4915-96ef-acce10336e0a",
						type: {
							id: "f903f2b0-eac0-11ee-ba26-017635aabc68",
							__typename: "DishTypeSubscription",
						},
						price: {
							default: null,
						},
						__typename: "DishSubscription",
					},
				],
				added: null,
				updated: null,
				__typename: "TransactionInventorySubscription",
			},
			payment: null,
			price: {
				total: {
					default: "159",
					current: "159",
					currency: CurrencyType.Czk,
					__typename: "PriceSubscription",
				},
				__typename: "OrderPriceSubscription",
			},
			__typename: "OrderSubscription",
		},
		__typename: "OrdersSubscription",
	},
	__typename: "FridgeTransactionSubscription",
};

export const getDishRemovedData = (variant?: WSDataVariant) => {
	const data: FridgeTransactionSubscription = { ...dishRemovedFridgeTransactionBase };
	switch (variant) {
		case WSDataVariant.EMPTY_ORDER_START:
			data.orders.last.inventory.removed = [];
			break;
		case WSDataVariant.LARGE_ORDER:
			data.orders.last.inventory.removed = [...removedMealsLargeOrder];
			break;
		case WSDataVariant.SMALL_ORDER:
			data.orders.last.inventory.removed = [
				{
					id: "556baf7b-cdbe-4915-96ef-acce10336e0a",
					type: {
						id: "f903f2b0-eac0-11ee-ba26-017635aabc68",
						__typename: "DishTypeSubscription",
					},
					price: {
						default: null,
					},
					__typename: "DishSubscription",
				},
			];
			break;
		case WSDataVariant.NATIVE_PAYMENT:
		default:
			// no need to alter data
			break;
	}
	return data;
};
